module.exports = __webpack_public_path__ + "img/thanq_logo.19254b31.svg";